export default __webpack_public_path__ + "static/media/andiamo_round.f5a9b89b.png";